import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0e7364a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-footer" }

import { ref } from "vue";
import EventsServices from "../../services/EventsServices";
import { EventShopOrderStatusTypes } from "@/core/types/shop/ShopPointsTypes";

export default /*#__PURE__*/_defineComponent({
  __name: 'RewardDetail',
  setup(__props, { expose: __expose }) {

const showDialog = ref(false);
const isLoading = ref(false);
const data = ref(<any>[]);
const show = (item: any) => {
  showDialog.value = true;
  fecthData(item);
};

const fecthData = async (item: any) => {
  isLoading.value = true;
  try {
    const res = await EventsServices.queryShopRewardById(item.id);
    data.value = res;
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};

__expose({
  show,
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: showDialog.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
    title: "Reward Detail",
    width: "800",
    "align-center": ""
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (showDialog.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.close")), 1)
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})